// Pont de navigation : permet de naviguer en SPA depuis l'extérieur du Router (ex: toasts Sonner)
export const navRef = { navigate: null };
export const goTo = (path) => {
  if (navRef.navigate) navRef.navigate(path);
  else window.location.href = path;
};
